/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserNameInfo
 */
export interface OrgUserNameInfo {
    /**
     * 
     * @type {string}
     * @memberof OrgUserNameInfo
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserNameInfo
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserNameInfo
     */
    last_name: string;
}

/**
 * Check if a given object implements the OrgUserNameInfo interface.
 */
export function instanceOfOrgUserNameInfo(value: object): value is OrgUserNameInfo {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function OrgUserNameInfoFromJSON(json: any): OrgUserNameInfo {
    return OrgUserNameInfoFromJSONTyped(json, false);
}

export function OrgUserNameInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserNameInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function OrgUserNameInfoToJSON(json: any): OrgUserNameInfo {
    return OrgUserNameInfoToJSONTyped(json, false);
}

export function OrgUserNameInfoToJSONTyped(value?: OrgUserNameInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

